<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <fieldset
      :disabled="readonly"
      style="border:0;padding:0;margin:0;min-width:0;"
    >
      <div class="card-body">
        <div class="text-right" v-if="!readonly">
          <form-button :indicator="form.processing()" v-on:clicked="submit">
            Save
          </form-button>
        </div>
        <div class="clearfix"></div>
        <hr />

        <div class="row">
          <div class="col-lg-6">
            <fieldset>
              <legend>
                Salvage Agent <small>- Details of the Salvage Agent</small>
              </legend>

              <inputbox
                v-model="form.agent_contact_name"
                name="agent_contact_name"
                helper="Please enter the agent name"
                label="Agent Name"
              ></inputbox>

              <inputbox
                v-model="form.agent_contact_email"
                name="agent_contact_email"
                helper="Please enter the agent email"
                label="Email"
              ></inputbox>

              <inputbox
                v-model="form.agent_contact_phone_number"
                name="agent_contact_phone_number"
                helper="Please enter the agent phone number"
                label="Phone Number"
              ></inputbox>

              <fieldset>
                <legend>
                  Agent Address
                  <small class="text-muted">
                    - Enter the agent address
                  </small>
                </legend>
                <address-lookup
                  :address="agentAddress"
                  v-on:address="setAgentAddress"
                ></address-lookup>
              </fieldset>
            </fieldset>
          </div>

          <div class="col-lg-6">
            <fieldset>
              <legend>Details</legend>

              <div class="form-group">
                <div class="col-lg-4">
                  <label
                    class="control-label"
                    style="text-align: left;"
                    for="salvage_settlement_accepted"
                  >
                    Salvage settlement accepted?
                  </label>
                </div>
                <div class="col-lg-8">
                  <toggleswitch
                    :labels="true"
                    name="salvage_settlement_accepted"
                    v-model="form.salvage_settlement_accepted"
                  ></toggleswitch>
                </div>
              </div>

              <datepicker-input
                v-model="form.salvage_settlement_accepted_at"
                name="salvage_settlement_accepted_at"
                label="Salvage settlement accepted date"
                helper="Please enter the date the salvage settlement was accepted"
                :disabled="dateRange"
                v-if="form.salvage_settlement_accepted"
              ></datepicker-input>

              <inputbox
                name="category"
                label="Category"
                v-model="form.category"
                helper="Category"
                :show-error="form.errors.has('category')"
                :error-message="form.errors.get('category')"
              ></inputbox>

              <div class="form-group">
                <div class="col-lg-4">
                  <label
                    class="control-label"
                    style="text-align: left;"
                    for="salvage_handler_id"
                  >
                    Salvage Handler
                  </label>
                </div>
                <div class="col-lg-8">
                  <select
                    class="form-control"
                    id="salvage_handler_id"
                    v-model="form.salvage_handler_id"
                  >
                    <option value="">Please Select</option>
                    <option
                      :key="index"
                      :value="handler.id"
                      v-for="(handler, index) in claimHandlers"
                    >
                      {{ handler.full_name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <div class="col-lg-4">
                  <label
                    class="control-label"
                    style="text-align: left;"
                    for="non_retention_reason_id"
                  >
                    Non-Retention Reason
                  </label>
                </div>
                <div class="col-lg-8">
                  <select
                    class="form-control"
                    id="non_retention_reason_id"
                    v-model="form.non_retention_reason_id"
                  >
                    <option value="">Please Select</option>
                    <option
                      :key="index"
                      :value="handler.id"
                      v-for="(handler, index) in nonRetentionReasons"
                    >
                      {{ handler.label }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <div class="col-lg-4">
                  <label
                    class="control-label"
                    style="text-align: left;"
                    for="hpi"
                  >
                    HPI clear?
                  </label>
                </div>
                <div class="col-lg-8">
                  <toggleswitch
                    :labels="true"
                    name="hpi"
                    v-model="form.hpi"
                  ></toggleswitch>
                </div>
              </div>

              <datepicker-input
                v-model="form.salvage_sold_at"
                name="salvage_sold_at"
                label="Salvage sold"
                helper="Please enter the date the salvage was sold"
                :disabled="dateRange"
              ></datepicker-input>

              <datepicker-input
                v-model="form.salvage_off_site_at"
                name="salvage_off_site_at"
                label="Salvage off site"
                helper="Please enter the date the salvage went off site"
                :disabled="dateRange"
              ></datepicker-input>

              <datepicker-input
                v-model="form.v5_received_at"
                name="v5_received_at"
                label="V5 received at"
                helper="Please enter the date the V5 was received"
                :disabled="dateRange"
              ></datepicker-input>

              <datepicker-input
                v-model="form.payment_to_client_at"
                name="payment_to_client_at"
                label="Payment To Client"
                helper="Please enter the date the payment was sent to the client"
                :disabled="dateRange"
              ></datepicker-input>
            </fieldset>

            <fieldset>
              <legend>Values</legend>

              <currency-input
                name="salvage_value"
                label="Salvage Value"
                v-model="form.salvage_value"
                helper="Please enter the salvage value"
                :show-error="form.errors.has('salvage_value')"
                :error-message="form.errors.get('salvage_value')"
              ></currency-input>

              <currency-input
                name="pav_value"
                label="PAV Value"
                v-model="form.pav_value"
                helper="Please enter the PAV Value"
                :show-error="form.errors.has('pav_value')"
                :error-message="form.errors.get('pav_value')"
              ></currency-input>

              <currency-input
                name="salvage_sale_price"
                label="Salvage Sale Price"
                v-model="form.salvage_sale_price"
                helper="Please enter the salvage sale price"
                :show-error="form.errors.has('salvage_sale_price')"
                :error-message="form.errors.get('salvage_sale_price')"
              ></currency-input>

              <currency-input
                name="salvage_profit"
                label="Salvage Profit"
                v-model="form.salvage_profit"
                helper="Please enter the salvage profit"
                :show-error="form.errors.has('salvage_profit')"
                :error-message="form.errors.get('salvage_profit')"
              ></currency-input>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="card-footer text-right" v-if="!readonly">
        <form-button :indicator="form.processing()" v-on:clicked="submit">
          Save
        </form-button>
      </div>
    </fieldset>
  </form>
</template>

<script>
import CurrencyInput from '@/components/Generic/Form/CurrencyInput';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    selectedService: {
      type: Object,
      required: false,
      default: null
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    CurrencyInput
  },

  data() {
    return {
      dateRange: {
        from: new Date()
      },
      form: new window.Form(
        {
          service_id: null,
          non_retention_reason_id: '',
          salvage_handler_id: '',
          salvage_value: null,
          pav_value: null,
          category: null,
          recovered_at: null,
          company_id: null,
          company_name: null,
          company_email_address: null,
          company_telephone_number: null,
          company_address_line_one: null,
          company_address_line_two: null,
          company_city: null,
          company_postcode: null,
          agent_contact_name: null,
          agent_contact_email: null,
          agent_contact_phone_number: null,
          agent_address_line_one: null,
          agent_address_line_two: null,
          agent_city: null,
          agent_postcode: null,
          salvage_settlement_accepted: false,
          salvage_settlement_accepted_at: null,
          salvage_sale_price: null,
          salvage_profit: null,
          salvage_sold_at: null,
          salvage_off_site_at: null,
          v5_received_at: null,
          payment_to_client_at: null,
          hpi: null
        },
        true
      ),
      salvage_exists: false,
      data_entered: false,
      companyTypes: ['salvage']
    };
  },

  computed: {
    salvage() {
      return this.$store.getters['Incident/salvage'];
    },

    getCompany() {
      return {
        company_id: this.form.company_id,
        name: this.form.company_name,
        email_address: this.form.company_email_address,
        telephone_number: this.form.company_telephone_number,
        address_line_one: this.form.company_address_line_one,
        address_line_two: this.form.company_address_line_two,
        city: this.form.company_city,
        postcode: this.form.company_postcode
      };
    },

    agentAddress() {
      return {
        address_line_one: this.form.agent_address_line_one,
        address_line_two: this.form.agent_address_line_two,
        city: this.form.agent_city,
        postcode: this.form.agent_postcode
      };
    },

    nonRetentionReasons() {
      return this.$store.getters['SalvageNonRetentionReasons/all'];
    },

    claimHandlers() {
      return this.$store.getters['ClaimHandlers/all'];
    }
  },

  mounted() {
    this.mount();
  },

  methods: {
    mount() {
      this.$store.commit('SalvageNonRetentionReasons/retrieve');
      this.$store.commit('ClaimHandlers/retrieve');

      if (this.salvage && this.salvage.identifier) {
        this.setSalvage(this.$store.getters['Incident/salvage']);
      }
    },

    setSalvage(salvage) {
      this.salvage_exists = true;
      this.form.non_retention_reason_id = salvage.non_retention_reason_id || '';
      this.form.salvage_handler_id = salvage.salvage_handler_id || '';
      this.form.salvage_value = salvage.salvage_value;
      this.form.pav_value = salvage.pav_value;
      this.form.category = salvage.category;
      this.form.recovered_at = salvage.recovered_at;
      this.form.company_id = salvage.company_id;
      this.form.company_name = salvage.company_name;
      this.form.company_email_address = salvage.company_email_address;
      this.form.company_telephone_number = salvage.company_telephone_number;
      this.form.company_address_line_one = salvage.company_address_line_one;
      this.form.company_address_line_two = salvage.company_address_line_two;
      this.form.company_city = salvage.company_city;
      this.form.company_postcode = salvage.company_postcode;
      this.form.agent_contact_name = salvage.agent_contact_name;
      this.form.agent_contact_email = salvage.agent_contact_email;
      this.form.agent_contact_phone_number = salvage.agent_contact_phone_number;
      this.form.agent_address_line_one = salvage.agent_address_line_one;
      this.form.agent_address_line_two = salvage.agent_address_line_two;
      this.form.agent_city = salvage.agent_city;
      this.form.agent_postcode = salvage.agent_postcode;
      this.form.salvage_settlement_accepted =
        salvage.salvage_settlement_accepted;
      this.form.salvage_settlement_accepted_at =
        salvage.salvage_settlement_accepted_at;
      this.form.salvage_sale_price = salvage.salvage_sale_price;
      this.form.salvage_profit = salvage.salvage_profit;
      this.form.salvage_sold_at = salvage.salvage_sold_at;
      this.form.salvage_off_site_at = salvage.salvage_off_site_at;
      this.form.v5_received_at = salvage.v5_received_at;
      this.form.payment_to_client_at = salvage.payment_to_client_at;
      this.form.hpi = salvage.hpi || false;
    },

    setAgentAddress(address) {
      this.form.agent_address_line_one = address.address_line_one;
      this.form.agent_address_line_two = address.address_line_two;
      this.form.agent_city = address.city;
      this.form.agent_postcode = address.postcode;
    },

    setRecoveryDate(value) {
      this.form.recovered_at = value;
    },

    setCompany(company) {
      this.form.company_id = company.company_id;
      this.form.company_name = company.name;
      this.form.company_email_address = company.email_address;
      this.form.company_telephone_number = company.telephone_number;
      this.form.company_address_line_one = company.address_line_one;
      this.form.company_address_line_two = company.address_line_two;
      this.form.company_city = company.city;
      this.form.company_postcode = company.postcode;
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    submit() {
      if (this.readonly) return;
      this.setCompany(this.$refs.company?.form || {});

      if (this.selectedService) {
        this.form.service_id = this.selectedService.id;
      }

      if (this.salvage_exists) {
        this.makeRequest('put');
        this.data_entered = false;
        this.$emit('unsaved-data', this.data_entered);
        return;
      }

      this.makeRequest('post');
      this.data_entered = false;
      this.$emit('unsaved-data', this.data_entered);
    },

    makeRequest(method) {
      this.form[method](`/incidents/${this.incident}/services/salvage`)
        .then(response => {
          if (!this.salvage_exists) {
            this.salvage_exists = true;
          }
          this.$store.commit('Incident/setSalvage', response);
          this.setSalvage(response);
          window.toastify.success(
            'Saved',
            'The salvage was saved successfully!'
          );
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            "We couldn't save the salvage - please try again."
          );
        });
    }
  }
};
</script>
